class AboutDirections extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-directions-trigger]');
    this.dialog = this.querySelector('[data-directions-dialog]');
    this.closeButton = this.querySelector('[data-directions-close]');

    if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;

    this.handleTrigger = this.handleTrigger.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleBackdrop = this.handleBackdrop.bind(this);

    this.trigger.addEventListener('click', this.handleTrigger);
    this.closeButton?.addEventListener('click', this.handleClose);
    this.dialog.addEventListener('click', this.handleBackdrop);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleTrigger);
    this.closeButton?.removeEventListener('click', this.handleClose);
    this.dialog?.removeEventListener('click', this.handleBackdrop);
  }

  handleTrigger(event) {
    const userAgent = navigator.userAgent || '';
    const isIOS = /iPad|iPhone|iPod/i.test(userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/i.test(userAgent);
    const shouldOfferMapApps = isIOS || isAndroid;

    // On desktop, preserve the anchor's normal behavior and open Google Maps directly.
    if (!shouldOfferMapApps) return;

    event.preventDefault();
    this.dialog.showModal();
  }

  handleClose() {
    this.dialog.close();
  }

  handleBackdrop(event) {
    if (event.target === this.dialog) this.dialog.close();
  }
}

if (!customElements.get('about-directions')) {
  customElements.define('about-directions', AboutDirections);
}
